import React from "react";
import "../css/TermsOfService.css";

const sections = [
  {
    title: "1. Acceptance of Terms",
    content:
      "By accessing the Sahara Public School website, you agree to comply with these Terms of Service and all applicable laws and regulations. If you do not agree with these terms, please discontinue use of the website.",
  },
  {
    title: "2. Website Usage",
    content:
      "The website is intended to provide information about our academic programs, admissions, events, and school activities. Users must not misuse, disrupt, or attempt unauthorized access to any part of the website.",
  },
  {
    title: "3. Admissions",
    content:
      "Submitting an admission enquiry or application does not guarantee admission. Admission decisions are based on school policies, eligibility, and seat availability.",
  },
  {
    title: "4. Intellectual Property",
    content:
      "All content, including logos, graphics, text, documents, and images on this website, belongs to Sahara Public School unless otherwise stated. Unauthorized reproduction or distribution is prohibited.",
  },
  {
    title: "5. User Responsibilities",
    content:
      "Users agree to provide accurate information in enquiry or admission forms and must not submit misleading or unlawful content.",
  },
  {
    title: "6. Privacy",
    content:
      "Personal information collected through forms is handled according to the school's Privacy Policy and applicable laws.",
  },
  {
    title: "7. External Links",
    content:
      "Our website may contain links to third-party websites for convenience. Sahara Public School is not responsible for their content or privacy practices.",
  },
  {
    title: "8. Limitation of Liability",
    content:
      "The school is not liable for interruptions, technical issues, inaccuracies, or damages resulting from use of this website.",
  },
  {
    title: "9. Changes to Terms",
    content:
      "These Terms of Service may be updated periodically. Continued use of the website after updates constitutes acceptance of the revised terms.",
  },
];

const TermsOfService = () => {
  return (
    <div className="terms-page">
      <header className="hero">
        <div className="hero-content">
          <h1>Terms of Service</h1>
          <p>
            Welcome to <strong>Sahara Public School</strong>. Please read these
            Terms of Service carefully before using our website.
          </p>
        </div>
      </header>

      <main className="terms-container">
        <section className="intro-card">
          <h2>Introduction</h2>

          <p>
            Sahara Public School is committed to maintaining a secure,
            informative, and reliable online platform for students, parents,
            teachers, and visitors.
          </p>

          <p>
            By accessing this website, you acknowledge that you have read,
            understood, and agreed to these Terms of Service.
          </p>
        </section>

        {sections.map((item, index) => (
          <section className="term-card" key={index}>
            <h2>{item.title}</h2>
            <p>{item.content}</p>
          </section>
        ))}

        <section className="contact-card">
          <h2>Contact Us</h2>

          <p>
            If you have any questions regarding these Terms of Service, please
            contact Sahara Public School.
          </p>

          <div className="contact-grid">
            <div>
              <h4>Email</h4>
              <p>info@saharapublicschool.edu</p>
            </div>

            <div>
              <h4>Phone</h4>
              <p>+91 98765 43210</p>
            </div>

            <div>
              <h4>Address</h4>
              <p>
                Sahara Public School
                <br />
                Ahmedabad, Gujarat
                <br />
                India
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TermsOfService;
